// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__BmHmU","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1K0aD"};